module.exports = __webpack_public_path__ + "static/media/landingSwipeThree.3593a0d6.png";